import { useEffect, useState } from "react";
import { getAllConnectionKeys } from "../services/connectionKeysService";

const useFetchAllConnectionKey = ({ connectionKeyIds, setIsLoading }: any) => {
  const [connectionKeysData, setConnectionKeysData] = useState<any[]>([]);
  useEffect(() => {
    const getConnectionKeysData = async () => {
      setIsLoading(true);
      try {
        let result;
        if (connectionKeyIds?.length > 0) {
          result = await getAllConnectionKeys(connectionKeyIds);
          setConnectionKeysData(result);
        } else {
          setConnectionKeysData([]);
        }
      } catch (err) {
        setConnectionKeysData([]);
      } finally {
        setIsLoading(false);
      }
    };
    getConnectionKeysData();
  }, [connectionKeyIds]); // ✅ Removed setIsLoading to prevent infinite loops

  return [connectionKeysData];
};

export default useFetchAllConnectionKey;
